import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../pages/landing.css';

// Logged-out marketing nav, shared by the landing page and the public
// marketing/legal pages (About, Pricing, Help, Privacy, Terms, Automation
// Disclosure). The authenticated app nav (AppNav) is shown to logged-in users.
// On narrow screens the links collapse into a hamburger menu.
export default function MarketingNav() {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="lp-nav">
      <div className="lp-nav-inner">
        <Link to="/" className="lp-brand" onClick={close}>Agence</Link>
        <button
          type="button"
          className={`lp-nav-toggle${open ? ' lp-nav-toggle--open' : ''}`}
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="lp-primary-nav"
          onClick={() => setOpen((o) => !o)}
        >
          <span /><span /><span />
        </button>
        <nav
          id="lp-primary-nav"
          className={`lp-nav-links${open ? ' lp-nav-links--open' : ''}`}
          aria-label="Primary"
        >
          <Link to="/about" onClick={close}>About</Link>
          <Link to="/pricing" onClick={close}>Pricing</Link>
          <Link to="/help" onClick={close}>Help</Link>
          <Link to="/login" className="lp-btn lp-btn--text" onClick={close}>Sign in</Link>
          <Link to="/register" className="lp-btn lp-btn--primary" onClick={close}>Get started</Link>
        </nav>
      </div>
    </header>
  );
}
